import { Paginated } from "../../../../common/domain/models/paginated_models";
import { ControleEstoqueFilter } from "../../domain/models/controle_estoque_filter";
import { ControleEstoque } from "../../domain/models/controle_estoque_lista";
import { EntradaProdutosFilter } from "../../domain/models/emtrada_produtos_filter";
import { EntradaProduto } from "../../domain/models/entrada_produtos_lista";
import { ItemControleEstoqueFilter } from "../../domain/models/item_controle_estoque_filter";
import { ItemControleEstoque } from "../../domain/models/item_controle_estoque_lista";
import { SaidaProdutosFilter } from "../../domain/models/saida_produtos_filter";
import { SaidaProduto } from "../../domain/models/saida_produtos_lista";
import { IEstoqueRepository } from "../../domain/repositories/estoque_repository";
import { CreateEntradaMultiPResponse } from "../daos/create/create_entrada_multi_produto";
import { CreateEntradaPResponse } from "../daos/create/create_entrada_produto";
import { CreateSaidaMultiPResponse } from "../daos/create/create_saida_multi_produto";
import { CreateSaidaPResponse } from "../daos/create/create_saida_produto";
import { IEstoqueService } from "../services/estoque_service";

export class EstoqueRepository implements IEstoqueRepository {
  constructor(private readonly service: IEstoqueService) { }

  // #region Entrada Produtos
  async getAllListagemEstoque(
    filter: EntradaProdutosFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<EntradaProduto>> {
    const response = await this.service.getAllListagemEstoque({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): EntradaProduto => ({
          IdEntradaProduto: item.idEntradaProduto,
          IdOrdemCompra: item.idOrdemCompra,
          NroOrdemCompra: item.nroOrdemCompra,
          IdCentroCusto: item.idCentroCusto,
          IdFornecedor: item.idFornecedor,
          IdOrdemCompraProduto: item.idOrdemCompraProduto,
          IdProdutoServico: item.idProdutoServico,
          IdSessaoMultipla: item.idSessaoMultipla,
          Data: item.data,
          NrNotaFiscal: item.nrNotaFiscal,
          NroNotaFiscal: item.nroNotaFiscal,
          Quantidade: item.quantidade,
          ValorUnitario: item.valorUnitario,
          NomeCentroCusto: item.nomeCentroCusto,
          NomeFornecedor: item.nomeFornecedor,
          NomeProdutoServico: item.nomeProdutoServico,
          ValorTotal: item.valorTotal,
          Unidade: item.unidade,
          codigo: item.codigo,
        }),
      ),
    };
  }

  async createEntradaP(
    Data: Date | null,
    DataNotaFiscal: Date | null,
    IdCentroCusto: number | null,
    IdProdutoServico: number | null,
    NroNotaFiscal: string | null,
    Quantidade: number | null,
    IdFornecedor: number | null,
    IdOrdemCompraProduto: number | null,
    NrNotaFiscal: string | null,
    IdSessaoMultipla: string | null,
    ValorUnitario: number | null,
  ): Promise<CreateEntradaPResponse> {
    const response = await this.service.createEntradaP({
      Data,
      dataNotaFiscal: DataNotaFiscal,
      IdCentroCusto,
      IdProdutoServico,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdOrdemCompraProduto,
      NrNotaFiscal,
      IdSessaoMultipla,
      ValorUnitario,
    });
    return response;
  }

  async createEntradaMultiP(
    Data: Date | null,
    IdCentroCusto: number | null,
    IdProdutoServicoM: number[] | null,
    NroNotaFiscal: string | null,
    Quantidade: number | null,
    IdFornecedor: number | null,
    IdOrdemCompraProduto: number | null,
    NrNotaFiscal: string | null,
    IdSessaoMultipla: string | null,
    ValorUnitario: number | null,
  ): Promise<CreateEntradaMultiPResponse> {
    const response = await this.service.createEntradaMultiP({
      Data,
      IdCentroCusto,
      IdProdutoServicoM,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdOrdemCompraProduto,
      NrNotaFiscal,
      IdSessaoMultipla,
      ValorUnitario,
    });

    return response;
  }

  async updateEntradaP(
    IdEntradaProduto: number,
    Data: Date | null,
    IdCentroCusto: number | null,
    IdProdutoServico: number | null,
    NroNotaFiscal: string | null,
    Quantidade: number | null,
    IdFornecedor: number | null,
    IdOrdemCompraProduto: number | null,
    NrNotaFiscal: string | null,
    IdSessaoMultipla: string | null,
    ValorUnitario: number | null,
  ): Promise<void> {
    await this.service.updateEntradaP({
      IdEntradaProduto,
      Data,
      IdCentroCusto,
      IdProdutoServico,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdOrdemCompraProduto,
      NrNotaFiscal,
      IdSessaoMultipla,
      ValorUnitario,
    });
  }

  async updateEntradaMultiP(EntradaProduto: EntradaProduto[]): Promise<void> {
    await this.service.updateEntradaMultiP({ EntradaProduto });
  }

  async deleteEntradaP(IdEntradaProduto: number): Promise<void> {
    await this.service.deleteEntradaP({ IdEntradaProduto });
  }

  //#endregion

  //#region Saida Produtos
  async getAllListagemSaida(
    filter: SaidaProdutosFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<SaidaProduto>> {
    const response = await this.service.getAllListagemSaida({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): SaidaProduto => ({
          IdSaidaProduto: item.idSaidaProduto,
          IdCentroCusto: item.idCentroCusto,
          IdFornecedor: item.idFornecedor,
          IdCentroCustoDestino: item.idCentroCustoDestino,
          IdProdutoServico: item.idProdutoServico,
          IdSessaoMultipla: item.idSessaoMultipla,
          Data: item.data,
          NrNotaFiscal: item.nrNotaFiscal,
          NroNotaFiscal: item.nroNotaFiscal,
          Quantidade: item.quantidade,
          ValorUnitario: item.valorUnitario,
          NomeCentroCustoDestino: item.nomeCentroCustoDestino,
          NomeFuncionario: item.nomeFuncionario,
          NomeCentroCustoSaida: item.nomeCentroCustoSaida,
          NomeFornecedor: item.nomeFornecedor,
          NomeProdutoServico: item.nomeProdutoServico,
          ValorTotal: item.valorTotal,
          IdFuncionario: item.idFuncionario,
          Unidade: item.unidade,
          UltimoValorUnitario: item.ultimoValorUnitario,
          LocalAplicacao: item.localAplicacao,
          codigo: item.codigo,
        }),
      ),
    };
  }
  async createSaidaP(
    Data?: Date | null,
    IdCentroCusto?: number | null,
    IdCentroCustoDestino?: number | null,
    IdProdutoServico?: number | null,
    NroNotaFiscal?: string | null,
    Quantidade?: number | null,
    IdFornecedor?: number | null,
    IdFuncionario?: number | null,
    NrNotaFiscal?: string | null,
    IdSessaoMultipla?: string | null,
    Delete?: boolean | null,
    ValorUnitario?: number | null,
    localAplicacao?: string | null,
  ): Promise<CreateSaidaPResponse> {
    const response = await this.service.createSaidaP({
      Data,
      IdCentroCusto,
      IdCentroCustoDestino,
      IdProdutoServico,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdFuncionario,
      NrNotaFiscal,
      IdSessaoMultipla,
      Delete,
      ValorUnitario,
      localAplicacao,
    });
    return response;
  }
  async updateSaidaP(
    IdSaidaProduto: number,
    Data?: Date | null,
    IdCentroCusto?: number | null,
    IdCentroCustoDestino?: number | null,
    IdProdutoServico?: number | null,
    NroNotaFiscal?: string | null,
    Quantidade?: number | null,
    IdFornecedor?: number | null,
    IdFuncionario?: number | null,
    NrNotaFiscal?: string | null,
    IdSessaoMultipla?: string | null,
    Delete?: boolean | null,
    ValorUnitario?: number | null,
    localAplicacao?: string | null,
  ): Promise<void> {
    await this.service.updateSaidaP({
      IdSaidaProduto,
      Data,
      IdCentroCusto,
      IdCentroCustoDestino,
      IdProdutoServico,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdFuncionario,
      NrNotaFiscal,
      IdSessaoMultipla,
      Delete,
      ValorUnitario,
      localAplicacao,
    });
  }
  async deleteSaidaP(IdSaidaProduto: number): Promise<void> {
    await this.service.deleteSaidaP({ IdSaidaProduto });
  }

  async createSaidaMultiP(
    Data?: Date | null,
    IdCentroCusto?: number | null,
    IdCentroCustoDestino?: number | null,
    IdProdutoServicoM?: number[] | null,
    NroNotaFiscal?: string | null,
    Quantidade?: number | null,
    IdFornecedor?: number | null,
    IdFuncionario?: number | null,
    NrNotaFiscal?: string | null,
    IdSessaoMultipla?: string | null,
    Delete?: boolean | null,
    ValorUnitario?: number | null,
    localAplicacao?: string | null,
  ): Promise<CreateSaidaMultiPResponse> {
    const response = await this.service.createSaidaMultiP({
      Data,
      IdCentroCusto,
      IdCentroCustoDestino,
      IdProdutoServicoM,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdFuncionario,
      NrNotaFiscal,
      IdSessaoMultipla,
      Delete,
      ValorUnitario,
      LocalAplicacao: localAplicacao,
    });

    return response;
  }

  async updateSaidaMultiP(SaidaProduto: SaidaProduto[]): Promise<void> {
    await this.service.updateSaidaMultiP({ SaidaProduto });
  }

  //#endregion

  //#region ControleEstoque
  async getAllListagemControle(
    filter: ControleEstoqueFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ControleEstoque>> {
    const response = await this.service.getAllListagemControle({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ControleEstoque => ({
          IdControleEstoque: item.idControleEstoque,
          IdCentroCusto: item.idCentroCusto,
          Descricao: item.descricao,
          NomeCentroCusto: item.nomeCentroCusto,
        }),
      ),
    };
  }
  async deleteControleEstoque(IdControleEstoque: number): Promise<void> {
    await this.service.deleteControleEstoque({ IdControleEstoque });
  }
  async createControle(
    IdCentroCusto?: number | null,
    Descricao?: string | null,
  ): Promise<void> {
    await this.service.createControle({ IdCentroCusto, Descricao });
  }
  async updateControle(
    IdControleEstoque: number,
    IdCentroCusto?: number | null,
    Descricao?: string | null,
  ): Promise<void> {
    await this.service.updateControle({
      IdControleEstoque,
      IdCentroCusto,
      Descricao,
    });
  }
  //#endregion
  //#region ItemControleEstoque
  async getAllListagemItemControle(
    filter: ItemControleEstoqueFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemControleEstoque>> {
    const response = await this.service.getAllListagemItemControle({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ItemControleEstoque => ({
          IdItemControleEstoque: item.idItemControleEstoque,
          IdControleEstoque: item.idControleEstoque,
          IdProdutoServico: item.idProdutoServico,
          QtdeEstoqueMin: item.qtdeEstoqueMin,
          QtdeEstoqueMax: item.qtdeEstoqueMax,
          LocalArmazenamento: item.localArmazenamento,
          NomeProdutoServico: item.nomeProdutoServico,
          QtdeEstoque: item.qtdeEstoque,
          Unidade: item.unidade,
          CssStatus: item.cssStatus,
          LabelStatus: item.labelStatus,
        }),
      ),
    };
  }
  async createItemControle(
    IdProdutoServico: number[] | null,
    IdControleEstoque: number,
  ): Promise<void> {
    await this.service.createItemControle({
      IdProdutoServico,
      IdControleEstoque,
    });
  }
  async updateItemControle(ItemControle: ItemControleEstoque[]): Promise<void> {
    await this.service.updateItemControle({ ItemControle });
  }
  async deleteItemControle(IdItemControleEstoque: number): Promise<void> {
    await this.service.deleteItemControle({ IdItemControleEstoque });
  }
  //#endregion
}
